import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { EXAMPLE_BUILDS } from "../../lib/builds";

export const BuildCards = ({ onPick }) => (
  <div className="grid gap-4 md:grid-cols-3">
    {EXAMPLE_BUILDS.map((b, i) => (
      <motion.article
        key={b.id}
        data-testid={`example-build-${b.id}`}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
        className="group flex flex-col border border-white/[0.08] bg-slab/70 transition-colors duration-500 hover:border-ember/50"
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img src={b.img} alt={b.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-slab via-transparent to-transparent" />
          <span className="absolute left-4 top-4 bg-ink/80 px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400 backdrop-blur">{b.target}</span>
        </div>
        <div className="flex flex-1 flex-col p-6">
          <h3 className="font-display text-3xl font-extrabold tracking-tight">{b.name}</h3>
          <p className="mt-2 text-sm text-slate-300">Great for: {b.for}</p>
          <dl className="mt-6 space-y-2 border-t border-white/[0.08] pt-5">
            {b.parts.map(([k, v]) => (
              <div key={k} className="grid grid-cols-[84px_1fr] gap-3 text-sm">
                <dt className="font-mono text-[11px] uppercase tracking-wider text-slate-400">{k}</dt>
                <dd className="text-bone">{v}</dd>
              </div>
            ))}
          </dl>
          <button
            type="button"
            data-testid={`pick-build-${b.id}`}
            onClick={() => onPick(b.name)}
            className="mt-auto inline-flex items-center justify-center gap-2 border border-white/15 px-5 py-3 pt-3 text-sm font-semibold transition-[border-color,background-color] duration-300 hover:border-ember hover:bg-ember hover:text-ink [margin-top:1.75rem]"
          >
            Get a quote for this build <ArrowDown className="h-4 w-4" />
          </button>
        </div>
      </motion.article>
    ))}
  </div>
);
